import { useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import CloseIcon from '@mui/icons-material/Close'
import SearchIcon from '@mui/icons-material/Search'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import moment from 'moment'

import { Flex, FlexContainer } from 'components/Flex'
import ListAction from 'components/ListAction'
import ListItem from 'components/ListItem'
import ListSort from 'components/ListSort'
import Panel from 'components/Panel'
import { orderBy, useDocs } from 'lib/firestore'

export default function AccountList() {
  const history = useHistory()
  const [sort, setSort] = useState({ field: 'createdAt', order: 'asc' })
  const [searchText, setSearchText] = useState('')
  const { items } = useDocs('accounts', orderBy(sort.field, sort.order))

  const handleChangeSort = field => {
    setSort(current => ({
      field,
      order: current.field !== field || current.order === 'desc' ? 'asc' : 'desc',
    }))
  }

  const accounts = useMemo(() => {
    if (!items) {
      return null
    }
    return items.filter(x => searchText === '' || Boolean(x.name.match(new RegExp(searchText))))
  }, [items, searchText])

  if (!accounts) {
    return (
      <FlexContainer style={{ alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </FlexContainer>
    )
  }

  return (
    <Flex>
      <ListAction>
        <TextField
          variant="outlined"
          size="small"
          onChange={e => setSearchText(e.target.value)}
          value={searchText}
          placeholder="アカウント名を入力"
          style={{ minWidth: 282 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchText !== '' && (
              <InputAdornment position="end">
                <IconButton onClick={() => setSearchText('')}>
                  <CloseIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </ListAction>
      <Panel>
        <ListSort
          title={`アカウント一覧（全 ${accounts.length} 件）`}
          fields={[
            { id: 'name', name: 'アカウント名' },
            { id: 'createdAt', name: '作成日' },
          ]}
          value={sort}
          onChange={handleChangeSort}
        />
        {accounts.map(x => (
          <ListItem
            key={x.id}
            primary={x.name}
            secondary={moment(x.createdAt).format('YYYY/MM/DD')}
            arrow
            onClick={() => history.push(`/accounts/${x.id}`)}
          />
        ))}
      </Panel>
    </Flex>
  )
}
